"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addonsUSD = exports.addonsRUB = void 0;
const enums_1 = require("./enums");
exports.addonsRUB = [
    {
        name: enums_1.AddonNames.WEBINAR,
        price: {
            [enums_1.PaymentPeriods.MONTHLY]: 99000,
            [enums_1.PaymentPeriods.ANNUAL]: 79000,
        },
        currency: enums_1.Currencies.RUB,
    },
];
exports.addonsUSD = [
    {
        name: enums_1.AddonNames.WEBINAR,
        price: {
            [enums_1.PaymentPeriods.MONTHLY]: 1499,
            [enums_1.PaymentPeriods.ANNUAL]: 1199,
        },
        currency: enums_1.Currencies.USD,
    },
];
//# sourceMappingURL=addons.js.map